import { render, staticRenderFns } from "./birthdays.vue?vue&type=template&id=97010782&scoped=true"
import script from "./birthdays.vue?vue&type=script&lang=js"
export * from "./birthdays.vue?vue&type=script&lang=js"
import style0 from "./birthdays.vue?vue&type=style&index=0&id=97010782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97010782",
  null
  
)

export default component.exports